export class SectorFondo {
    idSector: number;
    idFondo: number;
    Nombre_Sector?: string;
    Codigo_Sector?: string;
    Porcentaje: string; // convertir a number
    Porcentaje_Real: number;
    Monto_Sector_Fondo: string; // convertir a number
    Monto_Sector_Fondo_Disponible: string; // convertir a number
    Monto_Sector_Fondo_Ejecutado: string; // convertir a number
    Monto_Sector_Fondo_Bloqueado: string; // convertir a number
    Estado: string;
    Alta_Fecha: Date = new Date();
    Alta_Canal: string;
    Alta_Usuario: string;
    Modificacion_Fecha: Date = new Date();
    Modificacion_Canal: string;
    Modificacion_Usuario: string;
    nuevo?: boolean;
}